import { logger } from '@/utils/logger';

import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export type UserRole = 'admin' | 'staff' | 'donor';

export const useCurrentUserRole = () => {
  const { activeOrganizationId } = useAuth();

  return useQuery({
    queryKey: ['currentUserRole', activeOrganizationId],
    queryFn: async () => {
      logger.debug('🔍 Fetching current user role...');
      const { data: user } = await supabase.auth.getUser();
      logger.debug('👤 Current user:', user.user?.email, user.user?.id);
      
      if (!user.user?.id) {
        logger.debug('❌ No user ID found');
        return null;
      }
      
      const { data, error } = await supabase.rpc('get_user_role', {
        _user_id: user.user.id
      });
      
      if (error) {
        logger.error('❌ Error fetching user role:', error);
        throw error;
      }
      
      logger.debug('✅ User role fetched:', data);
      return (data ?? null) as UserRole | null;
    },
    enabled: !!activeOrganizationId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1
  });
};
